import {initialState as snackbarNotificationsState} from '../../components/SnackbarNotifications'
import {initialState as decryptContainerState} from '../../components/DecryptContainer'
import {initialState as recoveryContainerState} from '../../components/RecoveryContainer'

export default {
  ...snackbarNotificationsState,
  ...decryptContainerState,
  ...recoveryContainerState
}
